import { call, debounce, put, takeLatest } from 'redux-saga/effects';
import {
  fetchSampleDevelopmentPlApprovalRequestList,
  updateSampleDevelopmentPlApprovalRequesResponse,
} from '../../services/sampleDevelopmentPlApprovalRequestService';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { pushNotificationMessage } from '../../views/components/Notification';
import { AppAction } from '../app';
import {
  closeSampleDevelopmentPlApprovalRequestDialog,
  FETCH_SAMPLE_DEV_PL_APPROVAL_REQUEST_LIST,
  UPDATE_SAMPLE_DEV_PL_APPROVAL_REQUEST_RESPONSE,
} from './sampleDevelopmentPlApprovalRequest.actions';

function* fetchSasmpleDevelopmentPlApprovalRequestListSaga(action: AppAction) {
  try {
    yield put({ type: REQUEST(action.type) });
    const response = yield call(
      fetchSampleDevelopmentPlApprovalRequestList,
      action.payload,
    );
    const { data, headers } = response;
    yield put({ type: SUCCESS(action.type), payload: { data, headers } });
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

function* updateSasmpleDevelopmentPlApprovalRequestResponseSaga(action: AppAction) {
  try {
    const successMessage = `Updated sample development pl approval request successfully.`;
    yield put({ type: REQUEST(action.type) });
    const { data } = yield call(
      updateSampleDevelopmentPlApprovalRequesResponse,
      action.payload,
    );
    yield put({ type: SUCCESS(action.type), payload: { data } });
    yield put(pushNotificationMessage({ message: successMessage, type: 'success' }));
    yield put(closeSampleDevelopmentPlApprovalRequestDialog());
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

export default function* watchSampleDevelopmentPlApprovalRequest() {
  yield debounce(
    250,
    FETCH_SAMPLE_DEV_PL_APPROVAL_REQUEST_LIST,
    fetchSasmpleDevelopmentPlApprovalRequestListSaga,
  );
  yield takeLatest(
    UPDATE_SAMPLE_DEV_PL_APPROVAL_REQUEST_RESPONSE,
    updateSasmpleDevelopmentPlApprovalRequestResponseSaga,
  );
}
